import React from 'react';
import FieldGroup from '../../components/ui/FieldGroup';
import Spinner from '../../components/ui/Spinner';
import MapPicker from '../../components/MapPicker';

export default function CreateAssemblyModal({ form, setForm, onSubmit, saving, onClose }) {
  const minScheduledDate = `${new Date().getFullYear()}-01-01`;
  const mapAddressText = [form.address, form.colonia, form.postalCode].filter(Boolean).join(', ');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Programar Asamblea</h3>
          <button className="btn-icon" onClick={onClose}>✕</button>
        </div>

        <form onSubmit={onSubmit} className="modal-form">
          <div className="form-row3">
            <FieldGroup label="Fecha">
              <input type="date" value={form.scheduledDate}
                min={minScheduledDate}
                onChange={e => setForm(p => ({ ...p, scheduledDate: e.target.value }))} required />
            </FieldGroup>
            <FieldGroup label="Hora inicio">
              <input type="time" value={form.startTime}
                onChange={e => setForm(p => ({ ...p, startTime: e.target.value }))} required />
            </FieldGroup>
            <FieldGroup label="Hora término">
              <input type="time" value={form.endTime}
                onChange={e => setForm(p => ({ ...p, endTime: e.target.value }))} required />
            </FieldGroup>
          </div>

          <FieldGroup label="Domicilio / Calle y número" full>
            <input value={form.address} placeholder="Ej: Reforma 140"
              onChange={e => setForm(p => ({ ...p, address: e.target.value }))} required />
          </FieldGroup>

          <div className="form-row2">
            <FieldGroup label="Colonia">
              <input value={form.colonia}
                onChange={e => setForm(p => ({ ...p, colonia: e.target.value }))} required />
            </FieldGroup>
            <FieldGroup label="Código Postal">
              <input value={form.postalCode} maxLength={5}
                onChange={e => setForm(p => ({ ...p, postalCode: e.target.value }))} required />
            </FieldGroup>
          </div>

          <FieldGroup label="Referencias del domicilio" full>
            <textarea rows={2} value={form.references}
              placeholder="Frente al parque, referencia del lugar…"
              onChange={e => setForm(p => ({ ...p, references: e.target.value }))} required />
          </FieldGroup>

          <FieldGroup label="Ubicación en mapa" full>
            <MapPicker
              lat={form.lat}
              lng={form.lng}
              postalCode={form.postalCode}
              addressText={mapAddressText}
              onChange={(lat, lng) => setForm(p => ({ ...p, lat, lng }))}
            />
          </FieldGroup>

          <div className="modal-footer">
            <button type="button" className="btn-ghost" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? <Spinner /> : 'Programar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
